import {
  configureWebObservability,
  type WebObservability,
  type WebObservabilityOptions,
} from "@infinitaslearning/observability-web";
import type { Config } from "@/config";
import { name, version } from "../../../package.json";

const getObservabilityOptions = (environment: Config["ilEnv"]): WebObservabilityOptions => ({
  serviceName: name,
  serviceVersion: version,
  environment,
  transactionSampleRate: 1,
});

export const observability = {
  start: (environment: Config["ilEnv"]): { apm: WebObservability | null } => {
    // Completely skip APM in local development to avoid CORS errors
    // against the Elastic Cloud APM endpoint.
    if (environment === "local") {
      return { apm: null };
    }

    const options = getObservabilityOptions(environment);
    const apm = configureWebObservability(options);
    if (!apm) {
      throw new Error("Failed to initialize observability");
    }

    return { apm };
  },
};
